export default "__VITE_ASSET__4b9931ec__"